//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AutoFit",1,0],[1,"CheckPointSpacing",0,"Expression",0],[0,"DirectionOption",1,0],[1,"ElevationAngle",0,"Expression",0],[0,"HideSafeZone",1,0],[0,"LineScale",1,0],[1,"MaxAngle",0,"Expression",0],[1,"MinAngle",0,"Expression",0],[1,"PlaneAngle",0,"Expression",0],[1,"TrimmingCurves",0,"ScCollector",0],[0,"TrimmingDirection",1,"Direction",0],[1,"TrimmingFaces",0,"ScCollector",0]],[[["numJoinedSelectedCurves","joinedSelectedCurves"],"GetJoinedSelectedCurves",{},0,0],[["joinedSelectedCurves"],"SetJoinedSelectedCurves",{},1,0],[["numTrimSideTags","trimSideTags"],"GetTrimSideTags",{},0,0],[["trimSideTags"],"SetTrimSideTags",{},1,0],[["inputCrvs","distTol","numOutputCrvs","outputCrvs"],"JoinCurvesAndEdges",{},2,0]],[]];
SPLM.Tooling.DieEngTrimAngleCheckBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieEngTrimAngleCheckBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieEngTrimAngleCheckBuilder.DirectionOptions = Object.freeze({
    "ByVector" : "ByVector", "ByAngles" : "ByAngles"});

export default SPLM;